import 'bootstrap/dist/css/bootstrap.css';
import { useEffect, useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Button, Form } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Spinner from '../../shared/spinner';
import { ButtonAlterar, ButtonAtivar, ButtonInativar } from '../../shared/buttons';
import { faFilter, faRefresh } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ResponsivePagination from 'react-responsive-pagination';
import CustomAlert from '../../shared/customAlert';
import ConfirmModal from '../../shared/customAlertConfirm';
import { useVerificaPermissao } from '../../shared/useVerificaPermissao';
import RoleService from '../../services/roleInclusaoService';
import { UUID } from 'crypto';
import { RoleInclusaoDTO } from '../../shared/dto/roleInclusaoDTO';
import { ProtectedAction } from '../../AccessControl';
import { useSlug } from '../hooks/UseSlug';

interface RoleListDTO {
  id: UUID | string;
  descricao: string;
  tipoAcesso: 'INTERNO' | 'EXTERNO';
  dtInclusao: string | Date;
  status: boolean;
  nomesPais?: string; 
}

function RoleInclusaoComponent() {
  useVerificaPermissao();
  const navigate = useNavigate();
  
  const slug = useSlug(); 
  // --- LÓGICA DE CORREÇÃO DO SLUG ---
  // Se tiver slug, adiciona a barra antes. Se não, fica vazio.
  const basePath = slug ? `/${slug}` : ''; 

  const [alert, setAlert] = useState<{ message: string, type: 'success' | 'warning' | 'error' } | null>(null);

  const statusFl = [
    { value: 'Todos', label: 'Todos' },
    { value: 'Ativos', label: 'Ativos' },
    { value: 'Inativos', label: 'Inativos' },
  ];

  const [loading, setLoading] = useState(true);
  const [perfis, setPerfis] = useState<RoleListDTO[]>([]);

  const [filtros, setFiltros] = useState(false);
  const [descricaoFiltro, setDescricaoFiltro] = useState('');
  const [statusFiltro, setStatusFiltro] = useState(statusFl[0].value);

  const qtdRegistros = [10, 20, 30, 50, 100];
  const [pageSize, setPageSize] = useState(20);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const roleService: RoleService = new RoleService();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [currentAction, setCurrentAction] = useState<{ id: any; ativo: boolean } | null>(null);

  const listarTodosPerfis = async (max: number) => {
    try {
      setLoading(true);

      let filtro = new RoleInclusaoDTO();
      filtro.descricao = descricaoFiltro || undefined;
      filtro.status = statusFiltro === 'Todos' ? null : statusFiltro === 'Ativos' ? true : false;

      const responseList = await roleService.listarRolesPaginado(currentPage, max, filtro);

      const jsonList: RoleListDTO[] = responseList.data.content;
      console.log("Perfis recebidos:", jsonList);
      setPerfis(jsonList);
      setTotalPages(responseList.data.totalPages);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
      setAlert({ message: "Erro ao carregar lista de roles.", type: 'error' });
    }
  };

  const ativarInativarPerfil = async (id: any, ativo: boolean) => {
    setCurrentAction({ id, ativo });
    setConfirmOpen(true);
  };

  const handleConfirm = async () => {
    if (currentAction) {
      const { id, ativo } = currentAction;

      try {
        await roleService.ativarInativarRole(id);
        listarTodosPerfis(pageSize);
      } catch (err) {
        console.error(err);
      } finally {
        setConfirmOpen(false);
        setCurrentAction(null);
      }
    }
  };


  useEffect(() => {
    listarTodosPerfis(pageSize);
  }, [currentPage, pageSize]);


  return (
    <>
      {alert && (<CustomAlert message={alert.message} type={alert.type} onClose={() => setAlert(null)} />)}
      <div className="position-relative m-md-3">


        <div style={{ marginBottom: '15px', display: 'flex', justifyContent: 'space-between' }}>
          <h5>Configurações &gt; Perfis de Acesso</h5>
        </div>

        <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'space-between' }}>
          <Button id="App-button-cor-principal-escura" onClick={() => setFiltros(!filtros)}>
            <FontAwesomeIcon icon={faFilter} style={{ marginRight: '10px' }} />
            Filtros
          </Button>
          <div>
            <ProtectedAction> 
              <Button
              // USO DA VARIÁVEL basePath
              // Se slug existir: /slug/sistema-roles/inclusao
              // Se slug não existir: /sistema-roles/inclusao
                onClick={() => navigate(`${basePath}/sistema-roles/inclusao`, { state: { id: 0 } })}
                id="App-button-cor-principal-escura"
              >
                + Novo Perfil
              </Button>
            </ProtectedAction>
          </div>
        </div>

        {filtros && (
          <>
            <Row className="mb-4" style={{ marginTop: '15px' }}>
              <Form.Group as={Col} md='6' controlId="formDescricaoFiltro">
                <Form.Label>Descrição </Form.Label>
                <input type="text" className="form-control" value={descricaoFiltro} onChange={(e) => setDescricaoFiltro(e.target.value)} />
              </Form.Group>

              <Form.Group as={Col} md='3' controlId="formStatusFiltro">
                <Form.Label>Status</Form.Label>
                <select className="form-select" value={statusFiltro} onChange={(e) => setStatusFiltro(e.target.value)}>
                  {statusFl.map((item) => (
                    <option key={item.label} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </Form.Group>
            </Row>

            <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'space-between' }}>
              <Button id="App-button-cor-principal-escura" onClick={() => setFiltros(!filtros)}>
                <FontAwesomeIcon icon={faFilter} style={{ marginRight: '1px' }} />
              </Button>
              <Button id="App-button-cor-principal-escura" onClick={() => listarTodosPerfis(pageSize)}>
                <FontAwesomeIcon icon={faRefresh} style={{ marginRight: '1px' }} />
              </Button>
            </div>
          </>
        )}

        <Row style={{ justifyContent: 'center' }} className="mb-3">
          <Form.Group style={{ marginTop: '10px' }} as={Col} md='2' controlId="formBasicSelect">Registros Por Página</Form.Group>
          <Form.Group as={Col} md='1' controlId="formBasicSelect">
            <select className="form-select"
              defaultValue={pageSize} value={pageSize} onChange={(e) => {
                setPageSize(parseInt(e.target.value));
                setCurrentPage(0);
              }}
            >
              {qtdRegistros.map((qtd, index) => (
                <option key={index} value={qtd}>{qtd}</option>
              ))}
            </select>
          </Form.Group>
        </Row>

        {loading ? <Spinner loading={loading} /> : (
          <div className="table-responsive">
            <div>
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th scope="col" id="App-header-table" style={{ width: '40%' }}>Descrição</th>
                    <th scope="col" id="App-header-table" style={{ width: '25%' }}>Origem Vinculada</th>
                    <th scope="col" id="App-header-table" style={{ width: '15%' }}>Tipo de Acesso</th>
                    <ProtectedAction> 
                      <th scope="col" id="App-header-table" style={{ width: '5%' }}>Alteração</th>
                      <th scope="col" id="App-header-table" style={{ width: '5%' }}>Inativação</th>
                    </ProtectedAction> 
                  </tr>
                </thead>
                <tbody>
                  {perfis.map((item) => (
                    <tr key={item.id}>
                      <td>{item.descricao}</td>
                      <td>{item.nomesPais || '-'}</td>
                      <td>{item.tipoAcesso}</td>
                      <ProtectedAction> 
                        <td style={{ textAlign: 'center' }}>
                        {/* USO DA VARIÁVEL basePath NO LINK */}
                          <Link to={`${basePath}/sistema-roles/alteracao`} state={{ id: item.id }}>
                            <ButtonAlterar />
                          </Link>
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          {item.status ?
                            <ButtonAtivar onClick={() => ativarInativarPerfil(item.id, item.status)} />
                            :
                            <ButtonInativar onClick={() => ativarInativarPerfil(item.id, item.status)} />
                          }
                        </td>
                      </ProtectedAction> 
                    </tr>
                  ))}
                </tbody>
              </table>
              {confirmOpen && (<ConfirmModal message={currentAction?.ativo ? 'Tem certeza que deseja inativar este item?' : 'Tem certeza que deseja ativar este item?'} onConfirm={handleConfirm} onCancel={() => { setConfirmOpen(false); setCurrentAction(null) }} />)}
              <ResponsivePagination
                current={currentPage + 1}
                total={totalPages}
                onPageChange={(page) => setCurrentPage(page - 1)} />
            </div>
          </div>
        )}

      </div>
    </>
  );
}

export default RoleInclusaoComponent;